import {UpdateWatermarkV2RequestBody} from '@dms/api/shared';

import {WatermarkFormType} from '../types/WatermarkFormType';
import {getWatermarkVehicleSelection} from './getWatermarkVehicleSelection';

// The selection fields of the create and update body. Both are sent only when the form shows
// them: an omitted key keeps the stored value (PUT) or gets the BE default (POST), so a form
// without the feature leaves a stored selection untouched.
export const getVehicleSelectionRequestData = (
  data: Pick<WatermarkFormType, 'vehicleSelectionMode' | 'filter' | 'autoAssign'>,
  isVehicleSelectionEnabled: boolean
): Pick<UpdateWatermarkV2RequestBody, 'vehicleSelection' | 'autoAssign'> =>
  isVehicleSelectionEnabled
    ? {vehicleSelection: getWatermarkVehicleSelection(data), autoAssign: data.autoAssign}
    : {};
